import { Select as NBSelect } from 'native-base'
import { ForwardedRef, forwardRef, useCallback } from 'react'
import { Controller, FieldValues, get } from 'react-hook-form'

import { Field } from '../../molecules'
import type { ControlledSelectProps, RenderInputProps } from './types'

export function SelectInner<TFieldValues extends FieldValues>(
  { control, errors, name, onFocus, rules, ...props }: ControlledSelectProps<TFieldValues>,
  ref: ForwardedRef<typeof NBSelect>
) {
  const errorMessage = errors ? get(errors, name)?.message : undefined

  const renderSelect = useCallback(
    ({ field: { onChange, value, ...fieldProps } }: RenderInputProps<TFieldValues>) => {
      const handleOnValueChange = (val: string) => {
        props?.onValueChange?.(val)
        onChange(val)
      }
      return (
        <Field.Select
          {...props}
          {...fieldProps}
          errorMessage={errorMessage}
          //eslint-disable-next-line react/jsx-no-bind
          onValueChange={handleOnValueChange}
          ref={ref}
          selectedValue={value}
        />
      )
    },
    [ref, errorMessage, props]
  )
  return <Controller name={name} control={control} rules={rules} render={renderSelect} />
}

export const Select = forwardRef(SelectInner)
